import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormControl, FormArray } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

export function afterTodayValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const selectedDate = new Date(control.value);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);
  return selectedDate <= today ? { afterOrEqualToday: true } : null;
}

export function numberValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && isNaN(control.value)) {
    return { number: true };
  }
  return null;
}


@Component({
  selector: 'app-dish-payment',
  templateUrl: './dish-payment.component.html',
  styleUrl: './dish-payment.component.css'
})
export class DishPaymentComponent {
  @Input() fullData: any;
  @Output() creditInfo = new EventEmitter<any>();

  paymentForm: FormGroup;

  currentUser: any;
  states: any;

  loadingId: any;
  submittingBtn: boolean = false;


  constructor(
    private fb: FormBuilder,
    private message: NzMessageService,
    private data: DataserviceService
  ) {
    this.paymentForm = this.fb.group({
      cardNum: ['', [Validators.required, numberValidator]],
      nameOnCard: ['', Validators.required],
      expDate: ['', [Validators.required, afterTodayValidator]],
      cvv: ['', [Validators.required, numberValidator]],
      billingAddress: ['', Validators.required],
      billingCity: [''],
      billingState: [''],
      billingZip: [''],
      sameAsServiceAddress: [false]
    });

    this.states = this.data.states;
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');

    this.paymentForm.get('sameAsServiceAddress')?.valueChanges.subscribe((checked: boolean) => {
      if (checked) {
        const serviceVals = this.fullData.customerInfo || this.fullData;
        this.paymentForm.patchValue({
          billingAddress: serviceVals.address,
          billingCity: serviceVals.city,
          billingState: serviceVals.state,
          billingZip: serviceVals.zip
        });
        this.paymentForm.get('billingAddress')?.disable();
        this.paymentForm.get('billingCity')?.disable();
        this.paymentForm.get('billingState')?.disable();
        this.paymentForm.get('billingZip')?.disable();
      } else {
        this.paymentForm.get('billingAddress')?.enable();
        this.paymentForm.get('billingCity')?.enable();
        this.paymentForm.get('billingState')?.enable();
        this.paymentForm.get('billingZip')?.enable();
      }
    });

    this.paymentForm.get('expDate')?.setValidators([
      Validators.required,
      Validators.pattern(/^(0[1-9]|1[0-2])\/\d{2}$/)
    ]);

    if (this.fullData?.creditCard) {

      const expDate = this.fullData?.creditCard?.creditInfo?.expDate ? this.fullData?.creditCard?.creditInfo?.expDate.split('-')[1] + '/' + this.fullData?.creditCard?.creditInfo?.expDate.split('-')[0].slice(2) : null;

      this.paymentForm.patchValue({
        cardNum: this.fullData?.creditCard?.creditInfo.cardNum,
        nameOnCard: this.fullData?.creditCard?.creditInfo.nameOnCard,
        expDate: expDate,
        cvv: this.fullData?.creditCard?.creditInfo.cvv,
        sameAsServiceAddress: this.fullData?.creditCard?.creditInfo.sameAsServiceAddress
      })
    }

  }


  submitPay() {
    this.submittingBtn = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Submitting payment info...', { nzDuration: 0 }).messageId;
    const rawName = (this.paymentForm.get('nameOnCard')?.value || '').toString();
    const cleanedName = rawName.replace(/[^a-zA-Z\s]/g, ' ').replace(/\s+/g, ' ').trim();
    const splitName = cleanedName ? cleanedName.split(' ') : [];
    const firstToSend = splitName[0] || '';
    const lastToSend = splitName.length > 1 ? splitName[splitName.length - 1] : '';

    const obj = {
      customerId: this.fullData.customerId,
      // email: this.fullData.customerInfo.email,
      cardNumber: this.paymentForm.get('cardNum')?.value,
      expiration: '20' + this.paymentForm.get('expDate')?.value.split('/')[1] + '-' + this.paymentForm.get('expDate')?.value.split('/')[0],
      cvv: this.paymentForm.get('cvv')?.value,
      addressLine1: this.fullData.customerInfo?.address || this.fullData.address,
      city: this.fullData.customerInfo?.city || this.fullData.city,
      state: this.fullData.customerInfo?.state || this.fullData.state,
      zip: this.fullData.customerInfo?.zip || this.fullData.zip,
      cardType: 'AUTO_PAY_ENROLLMENT',
      autoPay: this.fullData.processingFee?.pfeeInfo?.autopay,
      first: firstToSend,
      last: lastToSend,
      conversationId: this.fullData.conversationId
    };

    this.data.postDataNoBodyDotBody(obj, 'dish/authorizeCreate').subscribe(
      (r: any) => {
        console.log(r);
        this.message.remove(this.loadingId);
        this.submittingBtn = false;

        if (!r || r.result !== 'success') {
          const msg = r?.message || 'Card could not be verified. Please try a different card.';
          this.message.error(msg, { nzDuration: 4000 });
          return;
        }

        const [mm, yy] = (this.paymentForm.get('expDate')?.value || '').split('/');
        this.paymentForm.get('expDate')?.setValue(`20${yy}-${mm}`);
        this.creditInfo.emit({ creditInfo: this.paymentForm.value });
      },
      (e) => {
        console.log('error', e);
        this.submittingBtn = false;
        this.message.remove(this.loadingId);
        this.message.error('Network error submitting payment. Please try again.');
      }
    );
  }

  onExpInput(event: any) {
    let input = event.target.value.replace(/\D/g, '');
    if (input.length > 2) {
      input = input.slice(0, 2) + '/' + input.slice(2, 4);
    }
    this.paymentForm.get('expDate')?.setValue(input, { emitEvent: false });
  }
}
